<template>
  <div class="sensor-list">
    <div
      class="sensor-list-item"
      :class="item.alarmState == 2 ? 'alarm-bg' : ''"
      v-for="(item, index) in list"
      :key="index"
    >
      <div class="sensor-list-item-name">
        <span>{{ item.showName || item.name }}</span>

        <!-- <span>{{ item.state }}</span> -->

        <i
          class="el-icon-message-solid"
          :class="'value' + item.alarmState"
          style="margin-left: 5px"
          v-if="item.alarmState && item.alarmState !== 0"
        ></i>
      </div>
      <div
        v-if="item.name == 'pm1' || item.name == 'pm25'"
        class="sensor-list-item-value"
        :style="{
          color: item.color
        }"
      >
        {{ item.value }}
      </div>
      <div v-else class="sensor-list-item-value" :class="'value' + item.alarmState">
        {{ item.value }}
      </div>
      <div class="sensor-list-item-unit">{{ item.unitName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
.sensor-list {
  padding: 10px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 20px;
  .alarm-bg {
    background-color: rgba(139, 0, 0, 0.7);
    border-color: rgba(139, 0, 0, 1) !important;
  }
  .sensor-list-item {
    padding: 10px;
    box-sizing: border-box;
    text-align: center;

    height: 120px;
    // border: 2px solid #04f3f2;
    border: 1px solid rgb(96, 118, 173);
    &-name,
    &-unit {
      font-size: 18px;
    }

    &-value {
      font-size: 22px;
      font-weight: bold;
    }

    .value0 {
      color: #00e401;
      //   color: #ff3c3b;
    }
    .value1 {
      color: #ff3c3b;
      //    color: #ff3c3b;
    }
    // .value2 {
    //   color: #ff3c3b;
    // }
    // .value3 {
    //   color: #ff7e01;
    // }
    // &:hover {
    //   background-color: var(--drone-sensor-bg-hover-color);
    // }
  }
}
</style>
